'use strict';

var framerMotion = require('framer-motion');
var React = require('react');
var _utils = require('./_utils.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const transitions = {
    enter: {
        duration: 0.2,
        ease: _utils.EASINGS.easeOut,
    },
    exit: {
        duration: 0.1,
        ease: _utils.EASINGS.easeIn,
    },
};
const variants = {
    initial: (props) => ({
        opacity: 0,
        x: props.offsetX,
        y: props.offsetY,
        transition: transitions.exit,
    }),
    exit: (props) => ({
        opacity: 0,
        transition: transitions.exit,
        ...(props.reverse && {
            x: props.offsetX,
            y: props.offsetY,
        }),
        ...(!props.reverse && {
            transitionEnd: {
                x: props.offsetX,
                y: props.offsetY,
            },
        }),
    }),
    enter: {
        opacity: 1,
        x: 0,
        y: 0,
        transition: transitions.enter,
    },
};
const slideFadeConfig = {
    variants,
    initial: 'initial',
    animate: 'enter',
    exit: 'exit',
};
const SlideFade = React__namespace.forwardRef((props, ref) => {
    const { unmountOnExit, visible, reverse = true, offsetX = 0, offsetY = 8, ...rest } = props;
    const show = unmountOnExit ? visible && unmountOnExit : true;
    const custom = React__namespace.useMemo(() => ({ offsetX, offsetY, reverse }), [offsetX, offsetY, reverse]);
    const motionProps = React__namespace.useMemo(() => ({
        ...slideFadeConfig,
        custom,
        animate: visible || unmountOnExit ? 'enter' : 'exit',
    }), [custom, visible, unmountOnExit]);
    return (React__namespace.createElement(framerMotion.AnimatePresence, { custom: custom }, show && React__namespace.createElement(framerMotion.motion.div, { ref: ref, ...motionProps, ...rest })));
});
SlideFade.defaultProps = {
    reverse: true,
    offsetX: 0,
    offsetY: 8,
};
SlideFade.displayName = 'SlideFade';

exports.SlideFade = SlideFade;
exports.slideFadeConfig = slideFadeConfig;
//# sourceMappingURL=SlideFade.js.map
